var React = require('react');

function Fire (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M8.043 6.293S8.79 1.905 5.745 0A5.37 5.37 0 0 1 3.72 3.887C2.42 5.03-.026 7.6 0 10.34A6.285 6.285 0 0 0 3.451 16a3.984 3.984 0 0 1 1.394-2.755 3.253 3.253 0 0 0 1.246-2.185 5.856 5.856 0 0 1 3.1 4.881v.013a5.883 5.883 0 0 0 3.428-5.106c.216-2.574-1.194-6.074-2.445-7.218a6.793 6.793 0 0 1-2.13 2.663z"}));
}

Fire.defaultProps = {"viewBox":"0 0 13 16"};

module.exports = Fire;

Fire.default = Fire;
